// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --workorder-bannder-height: 244px;
}

.workorder-header-start-section {
    min-height: var(--workorder-bannder-height);
    background: var(--bg-blue) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
    width: 100%;
}

.wrapper-workorder-header-section {
    width: 100%;
    min-height: var(--workorder-bannder-height);
    padding: var(--body-header-padding);
}

.workorder-header-search-group-section {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
}

.wrapper-workorder-header-search-group {
    min-height: 162px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 6px;
    display: grid;
    color: var(--neutral-color7);
    padding: 19px 35px;
    grid-row-gap: 10px;
    transition: all 0.5s;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child {
    font: normal normal 300 26px/32px Lato;
    letter-spacing: 0.26px;
    cursor: default;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child svg {
    margin-left: 10px;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr 0.2fr 2fr 0.8fr;
    grid-column-gap: 10px;
    align-items: center;
    min-height: 56px;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(2) {
    text-align: center;
    cursor: default;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3) .workorder-search-inner-group-section .custom-input-form-group .input-group .input-group-append{
    cursor: pointer;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child {
    height: 56px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    font: normal normal bold 16px/19px Lato;
    cursor: pointer;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);
    transition: all 0.5s;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child svg {
    margin-right: 10px;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child:hover {
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child {
    display: grid;
    grid-template-columns: 3.2fr 0.8fr;
    grid-column-gap: 10px;
}

.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child .workorder-header-advance-search-section {
    /* display: grid; */
    text-align: end;
    align-items: center;
    margin-top: 5px;
}

.workorder-header-search-group-row-section .workorder-header-advance-search-section {
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--call-to-action1);
}
.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child .workorder-header-advance-search-section > span{
    cursor: pointer;
}

.workorder-header-search-group-row-section .workorder-header-advance-search-section:hover {
    color: var(--call-to-action2);
}

.order-header-download-item-section{
    margin-left: 15px;
}
.order-header-download-item-section .item-list-download-btn-section{
    width: 122px;
    height: 28px;
    border: 1px solid var(--call-to-action1);
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);
    border-radius: 24px;
    text-align: center;
    font: normal normal bold 12px/15px Lato;
    letter-spacing: 0.24px;
    color: var(--call-to-action1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.order-header-download-item-section .item-list-download-btn-section svg{
    width: 11px;
    height: 11px;
    margin-left: 10px;
}


/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --workorder-bannder-height: 23.125rem;
    }
    .wrapper-workorder-header-search-group{
        min-height: 284px;
        padding: 0;
        background: transparent;
        color: var(--neutral-color1);
        grid-template-rows: 0.3fr 3fr 0.2fr;
    }
    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child{
        font: normal normal 300 18px/22px Lato;
        letter-spacing: 0.18px;
    }
    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child svg{
        width: 16px;
        height: 18px;
    }
    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2){
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }
    .wrapper-workorder-header-search-group label{
        color: var(--neutral-color6);
    }
    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3){
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
        margin-bottom: 10px;
    }
    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child{
        grid-template-columns: 1fr;
    }
    .workorder-header-search-group-row-section .workorder-header-advance-search-section{
        color: var(--neutral-color1);
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/WorkOrderHeader.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,sDAAsD;IACtD,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,+CAA+C;IAC/C,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,6DAA6D;IAC7D,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;;AAGA,wCAAwC;AACxC;IACI;QACI,qCAAqC;IACzC;IACA;QACI,iBAAiB;QACjB,UAAU;QACV,uBAAuB;QACvB,4BAA4B;QAC5B,mCAAmC;IACvC;IACA;QACI,sCAAsC;QACtC,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[":root {\r\n    --workorder-bannder-height: 244px;\r\n}\r\n\r\n.workorder-header-start-section {\r\n    min-height: var(--workorder-bannder-height);\r\n    background: var(--bg-blue) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-workorder-header-section {\r\n    width: 100%;\r\n    min-height: var(--workorder-bannder-height);\r\n    padding: var(--body-header-padding);\r\n}\r\n\r\n.workorder-header-search-group-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.wrapper-workorder-header-search-group {\r\n    min-height: 162px;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    border-radius: 6px;\r\n    display: grid;\r\n    color: var(--neutral-color7);\r\n    padding: 19px 35px;\r\n    grid-row-gap: 10px;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child {\r\n    font: normal normal 300 26px/32px Lato;\r\n    letter-spacing: 0.26px;\r\n    cursor: default;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child svg {\r\n    margin-left: 10px;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.2fr 2fr 0.8fr;\r\n    grid-column-gap: 10px;\r\n    align-items: center;\r\n    min-height: 56px;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(2) {\r\n    text-align: center;\r\n    cursor: default;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3) .workorder-search-inner-group-section .custom-input-form-group .input-group .input-group-append{\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child {\r\n    height: 56px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font: normal normal bold 16px/19px Lato;\r\n    cursor: pointer;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child svg {\r\n    margin-right: 10px;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:last-child:hover {\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 3.2fr 0.8fr;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child .workorder-header-advance-search-section {\r\n    /* display: grid; */\r\n    text-align: end;\r\n    align-items: center;\r\n    margin-top: 5px;\r\n}\r\n\r\n.workorder-header-search-group-row-section .workorder-header-advance-search-section {\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--call-to-action1);\r\n}\r\n.wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child .workorder-header-advance-search-section > span{\r\n    cursor: pointer;\r\n}\r\n\r\n.workorder-header-search-group-row-section .workorder-header-advance-search-section:hover {\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.order-header-download-item-section{\r\n    margin-left: 15px;\r\n}\r\n.order-header-download-item-section .item-list-download-btn-section{\r\n    width: 122px;\r\n    height: 28px;\r\n    border: 1px solid var(--call-to-action1);\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n    border-radius: 24px;\r\n    text-align: center;\r\n    font: normal normal bold 12px/15px Lato;\r\n    letter-spacing: 0.24px;\r\n    color: var(--call-to-action1);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n.order-header-download-item-section .item-list-download-btn-section svg{\r\n    width: 11px;\r\n    height: 11px;\r\n    margin-left: 10px;\r\n}\r\n\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --workorder-bannder-height: 23.125rem;\r\n    }\r\n    .wrapper-workorder-header-search-group{\r\n        min-height: 284px;\r\n        padding: 0;\r\n        background: transparent;\r\n        color: var(--neutral-color1);\r\n        grid-template-rows: 0.3fr 3fr 0.2fr;\r\n    }\r\n    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child{\r\n        font: normal normal 300 18px/22px Lato;\r\n        letter-spacing: 0.18px;\r\n    }\r\n    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:first-child svg{\r\n        width: 16px;\r\n        height: 18px;\r\n    }\r\n    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2){\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n    .wrapper-workorder-header-search-group label{\r\n        color: var(--neutral-color6);\r\n    }\r\n    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:nth-child(2) .workorder-search-group-section:nth-child(3){\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n        margin-bottom: 10px;\r\n    }\r\n    .wrapper-workorder-header-search-group .workorder-header-search-group-row-section:last-child{\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .workorder-header-search-group-row-section .workorder-header-advance-search-section{\r\n        color: var(--neutral-color1);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
